/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type {TaxClientDto} from './TaxClientDto';

export type TaxAbraDocumentTypeDto = {
    /**
     * Permissions defines what operations can logged user processed with this entity.
     */
    readonly _permissions?: Array<string>;
    client?: TaxClientDto;
    code?: string;
    /**
     * Date of creation of entity.
     */
    created: string;
    /**
     * Creator (username) of entity.
     */
    creator?: string;
    /**
     * Id of creator of entity.
     */
    creatorId?: string;
    externalId?: string;
    /**
     * Primary key (Id) of entity.
     */
    id: string;
    /**
     * Date of last modification of entity.
     */
    modified?: string;
    /**
     * Modifier (username) of entity.
     */
    modifier?: string;
    /**
     * Id of modifier of entity.
     */
    modifierId?: string;
    name?: string;
    /**
     * Original creator (username) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) creator of entity.
     */
    originalCreator?: string;
    /**
     * Original creator (ID) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) creator of entity.
     */
    originalCreatorId?: string;
    /**
     * Original modifier (username) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) modifier of entity.
     */
    originalModifier?: string;
    /**
     * Original modifier (ID) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) modifier of entity.
     */
    originalModifierId?: string;
    type?: TaxAbraDocumentTypeDto.type;
    valid?: boolean;
};

export namespace TaxAbraDocumentTypeDto {

    export enum type {
        INVOICE = 'INVOICE',
        RECEIPT = 'RECEIPT',
        CONFIRMATION = 'CONFIRMATION',
        OTHER = 'OTHER',
    }


}

